export type GetConfigurationOptions = {
  featureFlags?: Record<string, unknown>;
  userInfo?: Record<string, unknown>;
};

/**
 * Given a `onboardingConfigurationId`, return the matching configuration.
 */
export async function getConfiguration(
  onboardingConfigurationId: string,
  options?: GetConfigurationOptions,
) {
  const featureFlags = options?.featureFlags ?? {};
  const userInfo = options?.userInfo ?? {};

  switch (onboardingConfigurationId) {
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca":
      return (await import("./ca")).CaliforniaConfiguration;
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca-ukg":
      return (await import("./ca-ukg")).CaliforniaUKGConfiguration;
    case "ca-ukg-swing-cert":
      return (await import("./ca-ukg-swing-cert")).getCaliforniaUKGSwingCertConfiguration(
        featureFlags,
        userInfo,
      );
    case "ca-v4":
      return (await import("./ca-v4")).getCaliforniaV4Configuration(featureFlags, userInfo);
    case "nj":
      return (await import("./nj")).getNewJerseyConfiguration(featureFlags);
    case "tx-v1":
      return (await import("./tx-v1")).getTexasV1Configuration(featureFlags, userInfo);
    default: {
      throw new Error(`No configuration found for ${onboardingConfigurationId}`);
    }
  }
}
